// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconCustomIceCubeFilled = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '10',
      height: '12',
      viewBox: '0 0 10 12',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M9.07878 2.34163L5.7449 0.674967C5.27832 0.441678 4.72114 0.441678 4.25456 0.674967L0.921222 2.34163C0.353189 2.62592 0 3.19721 0 3.83252V8.01437C0 8.64968 0.353189 9.22097 0.921222 9.50526L4.2551 11.1719C4.48839 11.2886 4.74392 11.3466 5 11.3466C5.25608 11.3466 5.51216 11.2886 5.74544 11.1719L9.07878 9.50526C9.64681 9.22097 10 8.64968 10 8.01437V3.83252C10 3.19721 9.64681 2.62592 9.07878 2.34163ZM3.05556 7.59012C3.05556 7.74366 2.93132 7.86789 2.77778 7.86789C2.62424 7.86789 2.5 7.74366 2.5 7.59012V7.03456C2.5 6.88102 2.62424 6.75678 2.77778 6.75678C2.93132 6.75678 3.05556 6.88102 3.05556 7.03456V7.59012ZM6.72529 4.50527C6.34888 4.69346 6.11111 5.07818 6.11111 5.49902V7.59012C6.11111 7.89693 5.86239 8.14568 5.55556 8.14568C5.24872 8.14568 5 7.89693 5 7.59012V6.05458C5 5.63374 4.76223 5.24902 4.38582 5.06079L3.45757 4.59668C3.27287 4.50432 3.05556 4.63863 3.05556 4.84513V5.92345C3.05556 6.07699 2.93132 6.20123 2.77778 6.20123C2.62424 6.20123 2.5 6.07699 2.5 5.92345V4.80461C2.5 4.38373 2.2622 3.99901 1.88578 3.81078L1.23769 3.48676C1.28679 3.42596 1.34508 3.37201 1.41819 3.33556L4.75098 1.66889C4.8291 1.62983 4.91482 1.61084 5 1.61084C5.08572 1.61084 5.1709 1.62983 5.24848 1.66889L8.58182 3.33556C8.65492 3.37201 8.71321 3.42592 8.76231 3.48676L6.72529 4.50527Z',
      fill: 'currentColor',
    }),
  );

export { IconCustomIceCubeFilled };
